import React from 'react'
import type { RouteDef } from '@ztechapps/common.contract'
import { useHistory, useMutation } from '@ztechapps/common.hook'
import { createDefault } from '@ztechapps/blog.common'
import { WebuiIocKey, useInject } from '@ztechapps/webui.contract'
import { Field, FormModal } from '@ztechapps/webui.form'
import { TextAreaInput, TextInput } from '@ztechapps/webui.input'
import { queries } from '../graphql'
import { AddNewButton } from './AddNewButton'

export const AddForm = () => {
  const [onAdd] = useMutation({ ...queries.createConfig })
  const history = useHistory()
  const blogItemRoute = useInject<RouteDef>(WebuiIocKey.routes.blogItem)
  const blogDefault = createDefault()

  const initialValues = {
    title: blogDefault?.title,
    summary: blogDefault?.summary,
  }

  const validate = (values) => {
    const errors: any = {}
    if (!values.title) {
      errors.title = 'Required'
    }
    if (!values.summary) {
      errors.summary = 'Required'
    }
    return errors
  }

  const onSubmit = async ({ ...args }) => {
    const input = {
      ...args,
    }

    const { data, errors } = await onAdd({ input })
    if (errors) throw errors

    history.push(blogItemRoute.altPath({ _id: data?.createBlog?._id }))
  }
  return (
    <FormModal {...{ trigger: AddNewButton, initialValues, validate, onSubmit, title: 'Add new blog' }}>
      <Field name="title" component={TextInput} label="Title" initialValues={initialValues} />
      <Field name="summary" component={TextAreaInput} label="Summary" initialValues={initialValues} />
    </FormModal>
  )
}
